@if (state) {
  <div class="wm-statesummary" [ngClass]="{'no-hover': hardError||highlighted||!isLoaded||!state, 'highlighted': isLoaded && highlighted, 'not-loaded': !isLoaded || !state}" (click)="stateSummaryClicked()" attr.data-testing-id="statesummary-{{resourceId}}-container">
    @if (!hardError && !noScreenshot) {
      <div class="wm-statesummary-screenshot" attr.data-testing-id="statesummary-{{resourceId}}-screenshot">
        <wm-image [imageUrl]="state.firstScreenshotThumbnailUrl" [imageId]="state.firstScreenshotId" [allowToOpenScreenshotToolInPopup]="!nonInteractive"></wm-image>
      </div>
    }
    @if (!hardError && noScreenshot) {
      <div class="wm-statesummary-error" attr.data-testing-id="statesummary-{{resourceId}}-noscreenshot">
        <div class="wm-statesummary-error-icon">
          <fa-icon [icon]="faQuestionCircle"></fa-icon>
        </div>
        <span>Screenshot unavailable</span>
      </div>
    }
    @if (hardError) {
      <div class="wm-statesummary-error">
        <div class="wm-statesummary-error-icon"><fa-icon icon="frown-open" aria-hidden="true"></fa-icon></div>
        <span>State extraction failed</span>
      </div>
    }
    @if (!hardError && state !== undefined) {
      <div class="wm-statesummary-info">
        @if (issues) {
          <div class="wm-statesummary-issuecount" [ngClass]="{'wm-s-allfine': issueCount === 0, 'wm-s-inflight': issueCount === undefined}">
            @if (issueCount !== undefined) {
              <span>{{issueCount}}</span>
            }
          </div>
        }
        <div class="wm-statesummary-matchingid" [pTooltip]="customLabel ? customLabel : state?.description">{{customLabel ? customLabel : urlToDisplay}}</div>
      </div>
    }
  </div>
}
